var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCurveGlow = function SvgCurveGlow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 610,
    height: 32,
    viewBox: "-30 -30 670 92",
    fill: "none",
    style: {
      overflow: "visible"
    },
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "curveGlow",
    x: "-50%",
    y: "-200%",
    width: "200%",
    height: "500%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur1",
    "in": "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur2",
    "in": "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur3",
    "in": "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "blur1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "blur2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "blur3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#curveGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610 30H412.84C390.338 29.602 357.416 17.3898 357.416 17.3898C357.416 17.3898 328.422 2 307.024 2C285.627 2 252.583 17.3898 252.583 17.3898C252.583 17.3898 219.661 29.602 197.158 30H0",
    stroke: "#FFFFFF",
    strokeOpacity: 0.8,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M610 30H412.84C390.338 29.602 357.416 17.3898 357.416 17.3898C357.416 17.3898 328.422 2 307.024 2C285.627 2 252.583 17.3898 252.583 17.3898C252.583 17.3898 219.661 29.602 197.158 30H0",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCurveGlow);
export default ForwardRef;